export const VILLA_NADIA_IMAGE_COUNT = 28;

export const getVillaNadiaImagePath = (index) =>
  `/assets/images/villa-nadia/villa-nadia-${String(index).padStart(5, '0')}.webp`;

export const VILLA_NADIA_IMAGES = Array.from(
  { length: VILLA_NADIA_IMAGE_COUNT },
  (_, i) => getVillaNadiaImagePath(i + 1)
);

export const VILLA_NADIA_HERO_IMAGE = VILLA_NADIA_IMAGES[0];
